// "use strict";

// import React, { useMemo, useState } from "react";
// import classes from "./DialogueSearchFilter.module.css";

// export const DEFAULT_DIALOGUE_SEARCH_FILTERS = {
//   searchText: "",
//   searchIn: "all", // all | originalLanguageCode | translationLanguageCode
//   speaker: "",
//   originalAudioEmotion: "",
//   hasTranslatedAudio: "", // "" | "true" | "false"
// };

// export const hasAnyDialogueSearchFilter = (filters = {}) => {
//   return Boolean(
//     filters.searchText?.trim() ||
//       filters.speaker ||
//       filters.originalAudioEmotion ||
//       filters.hasTranslatedAudio === "true" ||
//       filters.hasTranslatedAudio === "false"
//   );
// };

// const DialogueSearchFilter = ({
//   value = DEFAULT_DIALOGUE_SEARCH_FILTERS,
//   onChange,
//   onSearch,
//   onClear,
//   characters = [],
//   emotionOptions = [],
//   loading = false,
//   getSpeakerDisplayName,

//   originalLanguageCode = "",
//   translationLanguageCode = "",
// }) => {
//   const [filterPanelOpen, setFilterPanelOpen] = useState(false);

//   const filters = {
//     ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
//     ...value,
//   };

//   const speakerOptions = useMemo(() => {
//     return characters
//       .filter((character) => character?.speaker)
//       .map((character) => ({
//         value: character.speaker,
//         label:
//           typeof getSpeakerDisplayName === "function"
//             ? getSpeakerDisplayName(character.speaker)
//             : character.displayName || character.speaker,
//       }));
//   }, [characters, getSpeakerDisplayName]);

//   const normalizedEmotionOptions = useMemo(() => {
//     return [...new Set(emotionOptions.filter(Boolean))].sort((a, b) =>
//       String(a).localeCompare(String(b))
//     );
//   }, [emotionOptions]);

//   const updateFilter = (field, nextValue) => {
//     onChange?.({
//       ...filters,
//       [field]: nextValue,
//     });
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     onSearch?.(filters);
//   };

//   const handleClear = () => {
//     onChange?.(DEFAULT_DIALOGUE_SEARCH_FILTERS);
//     onClear?.();
//   };

//   return (
//     <div className={classes["DialogueSearchFilterWrapper"]}>
//       <form
//         className={classes["DialogueSearchFilterBar"]}
//         onSubmit={handleSubmit}
//       >
//         <div className={classes["DialogueSearchInputWrapper"]}>
//           <span className={classes["DialogueSearchIcon"]}>⌕</span>

//           <input
//             className={classes["DialogueSearchInput"]}
//             value={filters.searchText}
//             placeholder="Search original or translated text..."
//             onChange={(event) =>
//               updateFilter("searchText", event.target.value)
//             }
//           />

//           <select
//             className={classes["DialogueSearchScopeSelect"]}
//             value={filters.searchIn}
//             onChange={(event) => updateFilter("searchIn", event.target.value)}
//             title="Choose where to search"
//           >
//             {/* <option value="all">Original + Translation</option> */}

//             {originalLanguageCode ? (
//               <option value={originalLanguageCode}>Original Language</option>
//             ) : null}

//             {translationLanguageCode ? (
//               <option value={translationLanguageCode}>Translation Language</option>
//             ) : null}
//           </select>
//         </div>

//         <button
//           type="button"
//           className={classes["DialogueFilterButton"]}
//           onClick={() => setFilterPanelOpen((prev) => !prev)}
//         >
//           Filters
//         </button>

//         <button
//           type="submit"
//           className={classes["DialogueSearchButton"]}
//           disabled={loading}
//         >
//           {loading ? "Searching..." : "Search"}
//         </button>
//       </form>

//       {filterPanelOpen ? (
//         <div className={classes["DialogueFilterPanel"]}>
//           <div className={classes["DialogueFilterRow"]}>
//             <label className={classes["DialogueFilterLabel"]}>Speaker</label>

//             <select
//               className={classes["DialogueFilterSelect"]}
//               value={filters.speaker}
//               onChange={(event) => updateFilter("speaker", event.target.value)}
//             >
//               <option value="">Any</option>
//               {speakerOptions.map((speaker) => (
//                 <option key={speaker.value} value={speaker.value}>
//                   {speaker.label}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className={classes["DialogueFilterRow"]}>
//             <label className={classes["DialogueFilterLabel"]}>Emotion</label>

//             <select
//               className={classes["DialogueFilterSelect"]}
//               value={filters.originalAudioEmotion}
//               onChange={(event) =>
//                 updateFilter("originalAudioEmotion", event.target.value)
//               }
//             >
//               <option value="">Any</option>
//               {normalizedEmotionOptions.map((emotion) => (
//                 <option key={emotion} value={emotion}>
//                   {emotion}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className={classes["DialogueFilterRow"]}>
//             <label className={classes["DialogueFilterLabel"]}>
//               Generated Audio
//             </label>

//             <select
//               className={classes["DialogueFilterSelect"]}
//               value={filters.hasTranslatedAudio}
//               onChange={(event) =>
//                 updateFilter("hasTranslatedAudio", event.target.value)
//               }
//             >
//               <option value="">Any</option>
//               <option value="true">Has generated audio</option>
//               <option value="false">No generated audio</option>
//             </select>
//           </div>

//           <div className={classes["DialogueFilterActions"]}>
//             <button
//               type="button"
//               className={classes["DialogueClearButton"]}
//               onClick={handleClear}
//               disabled={
//                 !hasAnyDialogueSearchFilter(filters) &&
//                 filters.searchIn === "all"
//               }
//             >
//               Clear filters
//             </button>
//           </div>
//         </div>
//       ) : null}
//     </div>
//   );
// };

// export default DialogueSearchFilter;




"use strict";

import React, { useMemo, useState } from "react";
import classes from "./DialogueSearchFilter.module.css";

export const DEFAULT_DIALOGUE_SEARCH_FILTERS = {
  searchText: "",
  searchIn: "all", // all | originalLanguageCode | translationLanguageCode
  speaker: "",
  originalAudioEmotion: "",
  hasTranslatedAudio: "", // "" | "true" | "false"
};

export const hasAnyDialogueSearchFilter = (filters = {}) => {
  return Boolean(
    filters.searchText?.trim() ||
      filters.speaker ||
      filters.originalAudioEmotion ||
      filters.hasTranslatedAudio === "true" ||
      filters.hasTranslatedAudio === "false"
  );
};

const DialogueSearchFilter = ({
  value = DEFAULT_DIALOGUE_SEARCH_FILTERS,
  onChange,
  onSearch,
  onClear,
  characters = [],
  emotionOptions = [],
  loading = false,
  getSpeakerDisplayName,

  originalLanguageCode = "",
  translationLanguageCode = "",

  showSearchScope = true,
  showGeneratedAudioFilter = true,
  searchPlaceholder = "Search original or translated text...",
}) => {
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);

  const filters = {
    ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
    ...value,
  };

  const speakerOptions = useMemo(() => {
    return characters
      .filter((character) => character?.speaker)
      .map((character) => ({
        value: character.speaker,
        label:
          typeof getSpeakerDisplayName === "function"
            ? getSpeakerDisplayName(character.speaker)
            : character.displayName || character.speaker,
      }));
  }, [characters, getSpeakerDisplayName]);

  const normalizedEmotionOptions = useMemo(() => {
    return [...new Set(emotionOptions.filter(Boolean))].sort((a, b) =>
      String(a).localeCompare(String(b))
    );
  }, [emotionOptions]);

  const updateFilter = (field, nextValue) => {
    onChange?.({
      ...filters,
      [field]: nextValue,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const submittedFilters = {
      ...filters,
      searchIn: showSearchScope
        ? filters.searchIn
        : originalLanguageCode || filters.searchIn || "all",
      hasTranslatedAudio: showGeneratedAudioFilter
        ? filters.hasTranslatedAudio
        : "",
    };

    onSearch?.(submittedFilters);
  };

  const handleClear = () => {
    const clearedFilters = {
      ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
      searchIn: showSearchScope
        ? "all"
        : originalLanguageCode || "all",
      hasTranslatedAudio: "",
    };

    onChange?.(clearedFilters);
    onClear?.();
  };

  const hasSearchScopeFilter = showSearchScope && filters.searchIn !== "all";

  return (
    <div className={classes["DialogueSearchFilterWrapper"]}>
      <form
        className={classes["DialogueSearchFilterBar"]}
        onSubmit={handleSubmit}
      >
        <div className={classes["DialogueSearchInputWrapper"]}>
          <span className={classes["DialogueSearchIcon"]}>⌕</span>

          <input
            className={classes["DialogueSearchInput"]}
            value={filters.searchText}
            placeholder={searchPlaceholder}
            onChange={(event) =>
              updateFilter("searchText", event.target.value)
            }
          />

          {showSearchScope ? (
            <select
              className={classes["DialogueSearchScopeSelect"]}
              value={filters.searchIn}
              onChange={(event) => updateFilter("searchIn", event.target.value)}
              title="Choose where to search"
            >
              <option value="all">Original + Translation</option>

              {originalLanguageCode ? (
                <option value={originalLanguageCode}>Original only</option>
              ) : null}

              {translationLanguageCode ? (
                <option value={translationLanguageCode}>Translation only</option>
              ) : null}
            </select>
          ) : null}
        </div>

        <button
          type="button"
          className={classes["DialogueFilterButton"]}
          onClick={() => setFilterPanelOpen((prev) => !prev)}
        >
          Filters
        </button>

        <button
          type="submit"
          className={classes["DialogueSearchButton"]}
          disabled={loading}
        >
          {loading ? "Searching..." : "Search"}
        </button>
      </form>

      {filterPanelOpen ? (
        <div className={classes["DialogueFilterPanel"]}>
          <div className={classes["DialogueFilterRow"]}>
            <label className={classes["DialogueFilterLabel"]}>Speaker</label>

            <select
              className={classes["DialogueFilterSelect"]}
              value={filters.speaker}
              onChange={(event) => updateFilter("speaker", event.target.value)}
            >
              <option value="">Any</option>
              {speakerOptions.map((speaker) => (
                <option key={speaker.value} value={speaker.value}>
                  {speaker.label}
                </option>
              ))}
            </select>
          </div>

          <div className={classes["DialogueFilterRow"]}>
            <label className={classes["DialogueFilterLabel"]}>Emotion</label>

            <select
              className={classes["DialogueFilterSelect"]}
              value={filters.originalAudioEmotion}
              onChange={(event) =>
                updateFilter("originalAudioEmotion", event.target.value)
              }
            >
              <option value="">Any</option>
              {normalizedEmotionOptions.map((emotion) => (
                <option key={emotion} value={emotion}>
                  {emotion}
                </option>
              ))}
            </select>
          </div>

          {showGeneratedAudioFilter ? (
            <div className={classes["DialogueFilterRow"]}>
              <label className={classes["DialogueFilterLabel"]}>
                Generated Audio
              </label>

              <select
                className={classes["DialogueFilterSelect"]}
                value={filters.hasTranslatedAudio}
                onChange={(event) =>
                  updateFilter("hasTranslatedAudio", event.target.value)
                }
              >
                <option value="">Any</option>
                <option value="true">Has generated audio</option>
                <option value="false">No generated audio</option>
              </select>
            </div>
          ) : null}

          <div className={classes["DialogueFilterActions"]}>
            <button
              type="button"
              className={classes["DialogueClearButton"]}
              onClick={handleClear}
              disabled={
                !hasAnyDialogueSearchFilter(filters) && !hasSearchScopeFilter
              }
            >
              Clear filters
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DialogueSearchFilter;